import notificationConstants    from './notification.constants';
import notificationInitialState from './notification.state';

function notificationReducer(state = notificationInitialState, action) {
  switch (action.type) {
    case notificationConstants.SHOW_MODAL:
      state = {
        open:        true,
        title:       action.title,
        description: action.description,
      };
      break;

    case notificationConstants.HIDE_MODAL:
      state = { ...notificationInitialState };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default notificationReducer;